import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export const IconUser = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24" fill="none">
    <path
      d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
      fill="currentColor"
    />
    <path
      d="M4 18C4 19.6569 5.34315 21 7 21H17C18.6569 21 20 19.6569 20 18C20 16.3431 18.5 13 12 13C5.5 13 4 16.3431 4 18Z"
      fill="currentColor"
    />
  </SvgIcon>
)
